import { Component } from 'vue-facing-decorator';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/Financials/Costs/Domain/queries';

@Component
export default class CostsQueries extends VueCqrs
{
	runManageCostsPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildManageCostsPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runExpenseAccountsByStrategyIdQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildExpenseAccountsByStrategyIdQueryV1(workspaceId, strategyId);
		this.$query(query);
	}

	runExpenseAccountByIdQueryV1(workspaceId: number, strategyId: string, expenseId: string)
	{
		const query = q.buildExpenseAccountByIdQueryV1(workspaceId, strategyId, expenseId);
		this.$query(query);
	}
}